export default "__VITE_ASSET__DUE5ndxP__"